<template>
    <div id="header" style="z-index:1000;">

        <transition name="curtain">
            <div class="curtain" v-if="AvatarDropDownVisible"></div>
        </transition>

        <!-- <img id="logo" src="../../public/Logo32x32.svg" /> -->
        <img id="logo" v-bind:src="appLogo" />

        <div id="avatar" v-if="UserData!=null" @click="toggleAvatarDropDown()" @focusout="hideAvatarDropDown()" class="no-outline" tabindex="1">
            <Avatar :UserName="UserData.userName" :Initials="UserData.initials" style="cursor:pointer;" />
            <transition name="headermodal">
                <div class="avatarmodal" v-show="AvatarDropDownVisible">
                    <Avatar id="bigavatar"
                            :UserName="UserData.userName"
                            :Initials="UserData.initials"
                            style="cursor:pointer;"
                            Size="large"
                            @click="SetOpenAvatarImageRightPanel">
                    </Avatar>

                    <span class="username">{{UserData.name}}</span>
                    <hr />

                    <!-- <div class="headerbtn" @click="changeTheme"><img src="../../public/icons/header/color.svg" style="visibility:hidden" />{{Localizer.Localize("Header_Change_Theme")}}</div> -->
                    <!-- <div class="headerbtn" @click="goToNotifications"><img src="../../public/icons/header/color.svg" style="visibility:hidden" />{{Localizer.Localize("Header_System_Log")}}</div> -->
                    <div class="headerbtn" @click="contactSupport" v-if="!hideFluenceHelp"><img src="../../public/icons/header/color.svg" style="visibility:hidden" />{{Localizer.Localize("Header_Support")}}</div>
                    <hr />
                    <div class="headerbtn" @click="Signout_Click"><img src="../../public/icons/header/color.svg" style="visibility:hidden" />{{Localizer.Localize("Header_Sign_Out")}}</div>
                </div>
            </transition>
        </div>
        <div id="avatar" v-else class="no-outline" tabindex="1">
            <Avatar :Initials="UserApiClientInitials" />
        </div>

        <input id="avatarImageSelector" ref="avatarImageSelector" type="file" style="display: none;" @change="UploadUserImage" accept="image/png" />


        <component v-if="OpenAvatarImageRightPanel" :is="RightPanelComponent" @close="OpenAvatarImageRightPanel=false" style="font-size:14px; color:var(--foreground-primary);">
            <template v-slot:header>
                <span class="title">Choose Avatar Image</span>
            </template>
            <template v-slot:body>
                <div></div>
            </template>
            <template v-slot:footer>
                <div class="panelButtons">
                    <CommonButton
                        :type="ButtonType.Default"
                        :text="Localizer.Localize('Cancel_PascalCase')"
                        @click="OpenAvatarImageRightPanel=false"/>
                    <CommonButton
                        :type="ButtonType.Primary"
                        :text="Localizer.Localize('Pick_File')"
                        @click="OpenFilePicker()"/>
                </div>
            </template>
        </component>

    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from 'vue-facing-decorator';
    import { Localizer } from "../api/Localizer";
    import * as api from "../api/ApiClient";
    import * as base from "../api/ApiClientBase";
    import RouteNames from '../routing/RouteNames';

    import Avatar from './helpers/Avatar.vue';
    import RightPanel from "./helpers/RightPanel.vue";
    import RightPanelV2 from "./helpers/RightPanel_v2.vue";
    import Spinner from "./helpers/Spinner.vue";
    import HtmlEditor from "../components/pages/workflow/Editors/Controls/HtmlEditor.vue";
    import { AuthClient } from "../api/ApiClientBase";
    import CommonButton from "./helpers/CommonButton.vue";
    import { ButtonType } from "./helpers/HelpersInterface";


    @Component({ components: { Avatar, RightPanel, RightPanelV2, Spinner, Watch, HtmlEditor, AuthClient, CommonButton } })
    export default class Header extends Vue {

        private Localizer = new Localizer(this.$store);
        private RouteNames = RouteNames;
        private ButtonType = ButtonType;


        get Tenant(): api.Tenant { return this.$store.state.security.Tenant; }
        get UserName(): api.Tenant { return this.$store.state.security.UserName; }
        get UserData(): api.ExtendedUserData { return this.$store.state.security.UserData; }
        get NewVersionDownloading(): boolean { return this.$store.state.NewVersionDownloading; }
        get NewVersionDownloaded(): boolean { return this.$store.state.NewVersionDownloaded; }

        get UserApiClientInitials() {
            return this.$store.getters['security/userClientInitials'];
        }

        get useRightHandPanels(): boolean {
            return this.$store.getters['security/RightHandPanelsFeatureFlagValue'];
        }

        get RightPanelComponent(): string {
            return this.useRightHandPanels ? 'RightPanelV2' : 'RightPanel';
        }

        AvatarDropDownVisible: boolean = false;
        toggleAvatarDropDown() {
            this.AvatarDropDownVisible = !this.AvatarDropDownVisible;
            if (this.AvatarDropDownVisible)
                this.OpenAvatarImageRightPanel = false;
        }

        hideAvatarDropDown() {
            this.AvatarDropDownVisible = false;
        }

        get hideFluenceHelp() {
            var forceupdate = this.UserData?.tenant;
            var hide = this.UserData == null || AuthClient.configuration.$config?.hideFluenceHelp;
            return hide ?? false;
        }

        mounted() {
        }

        get appLogo() {
            return this.$store.state.Theme['--main-logo'];
        }

        goToNotifications() {
            this.$router.push({ name: RouteNames.NotificationRoute });
        }

        Signout_Click() {
            this.$store.dispatch("security/LogOut");
        }

        RefreshBrowser() {
            window.location.reload();
        }

        contactSupport() {
            var url = "https://portal.anaplan.com/csm";
            window.open(url, '_blank', 'noreferrer');
        }

        private OpenAvatarImageRightPanel: boolean = false;
        private IsBusy: boolean = false;
        private AiPrompt: string = "";
        private AiUrl: string = "";

        SetOpenAvatarImageRightPanel() {
            this.OpenAvatarImageRightPanel = true;
            this.AiUrl = '';

            setTimeout(() => {
                var x = document.getElementById("AvatarAiPrompt");
                // x!.focus();
            }, 150)
        }

        OpenFilePicker() {
            var avatarImageSelector: HTMLInputElement | null = this.$refs.avatarImageSelector as HTMLInputElement;
            if (avatarImageSelector != null)
                avatarImageSelector.click();
            else
                console.log("avatarImageSelector is null");
        }

        async GenerateAiImage() {
            this.IsBusy = true;

            try {
                const authClient = base.AuthClient.getInstance();
                await authClient.ensureToken();
                const client = new api.SecurityClient(authClient);
                //this.AiUrl = "data:image/png;base64, " + await client.generateUserImage(this.AiPrompt);
            }
            catch (e) {
                await this.$store.dispatch("ShowToastError", e);
            }

            this.IsBusy = false;
        }

        async UploadAiImage() {

            try {
                const authClient = base.AuthClient.getInstance();
                await authClient.ensureToken();
                const client = new api.SecurityClient(authClient);

                const b64toBlob = (b64Data: string, contentType = '', sliceSize = 512) => {
                    const byteCharacters = atob(b64Data);
                    const byteArrays = [];

                    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                        const slice = byteCharacters.slice(offset, offset + sliceSize);

                        const byteNumbers = new Array(slice.length);
                        for (let i = 0; i < slice.length; i++) {
                            byteNumbers[i] = slice.charCodeAt(i);
                        }

                        const byteArray = new Uint8Array(byteNumbers);
                        byteArrays.push(byteArray);
                    }

                    const blob = new Blob(byteArrays, { type: contentType });
                    return blob;
                }
                await this.$store.dispatch("ShowToast", new api.ToastNotification({
                    message: this.Localizer.Localize("Header_Uploading_Avatar_Image"),
                    type: api.ToastType.Info
                }));

                const blob = b64toBlob(this.AiUrl.substring("data:image/png;base64, ".length), "image/png");
                await client.setUserImage({ fileName: 'ai.png', data: blob as Blob });

                await this.$store.dispatch("ShowToast", new api.ToastNotification({
                    message: this.Localizer.Localize("Header_Avatar_image_changed"),
                    type: api.ToastType.Info
                }));

                localStorage.removeItem("Avatar_" + this.UserName);
                //await this.onUserNameChange();

                this.$store.commit("security/IncreaseAvatarVersion");
            }
            catch (err) {
                this.$store.dispatch("ShowToastError", err);
            }
        }

        async UploadUserImage() {

            var fileToUpload: File | null = null;
            var avatarImage: HTMLInputElement | null = this.$refs.avatarImageSelector as HTMLInputElement;

            if (avatarImage && avatarImage.files && avatarImage.files.length > 0) {
                var fileToUpload = avatarImage.files.item(0);

                var filePath = fileToUpload!.name;

                if (!filePath.endsWith(".png")) {
                    await this.$store.dispatch("ShowToastError", this.Localizer.Localize("Header_Only_png_images"));
                }
                else {
                    try {
                        const authClient = base.AuthClient.getInstance();
                        await authClient.ensureToken();
                        const client = new api.SecurityClient(authClient);
                        await client.setUserImage({ fileName: filePath, data: fileToUpload as Blob });

                        await this.$store.dispatch("ShowToast", new api.ToastNotification({
                            message: this.Localizer.Localize("Header_Avatar_image_changed"),
                            type: api.ToastType.Info
                        }));

                        localStorage.removeItem("Avatar_" + this.UserName);
                        //await this.onUserNameChange();

                        this.$store.commit("security/IncreaseAvatarVersion");
                    }
                    catch (err) {
                        this.$store.dispatch("ShowToastError", err);
                    }
                }
            }
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #header {
        background-color: var(--header-background);
        color: var(--accent-foreground);
        height: 46px;
        width: 100%;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        z-index: 2000;
    }

    #logo {
        margin-top: 7px;
        margin-left: 17px;
        width: 32px;
        height: 32px;        
    }

    #avatar {
        margin-top: 6px;
        margin-right: 10px;
        float: right;
    }

    #bigavatar {
        margin-top: 14px;
        margin-left: 12px;
        display: inline-block;
    }

    #chat {
        height: 46px;
        float: right;
        text-align: center;
        line-height: 46px;
        margin-right: 8px;
        color: #242D48 !important;
    }

    .curtain {
        position: fixed;
        z-index: 3000;
        top: 86px;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background-color: var(--background-curtain);
    }

    .curtain-enter-active, .curtain-leave-active {
        transition: opacity .3s;
    }

    .curtain-enter-from, .curtain-leave-to {
        opacity: 0;
    }


    .no-outline {
        outline: none;
    }

    .avatarmodal {
        color: #555555;
        background-color: #FFFFFF;
        box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.25);
        border-radius: 4px;
        position: fixed;
        margin-left: -205px;
        margin-top: 6px;
        width: 250px;
        z-index: 4000;
        text-align: left;
    }

    .headermodal-enter-active, .headermodal-leave-active {
        transition: all .3s ease;
    }

    .headermodal-enter-from, .headermodal-leave-to {
        transform: translateY(10px);
        opacity: 0;
    }

    .username {
        margin-left: 19px;
        font-size: 14px;
        font-weight: bold;
    }

    .headerbtn {
        cursor: pointer;
        padding-right: 10px;
        padding-left: 10px;
        line-height: 40px;           
    }

        .headerbtn:hover {
            background-color: var(--header-btn-hover);
        }

    hr {
        margin-top: 11px;
        margin-bottom: 11px;
    }

    .notification {
        position: absolute;
        float: left;
        top: 0px;
        left: 0px;
        right: 0px;
        padding: 3px 10px;
        background-color: lightgoldenrodyellow;
        color: gray;
        border: 1px solid gray;
    }

    .closeNotification {
        float: right;
        margin: 3px;
        width: 18px;
        height: 18px;
    }

</style>
